import React from 'react';
import styles from './Tabs.module.scss';

export interface TabItem<T extends string> {
    key: T;
    label: string
    badge?: { value: number | string; tone?: 'neutral' | 'warning' };
}

interface TabsProps<T extends string> {
    items: TabItem<T>[];
    active: T;
    onChange: (key: T) => void;
}

export function Tabs<T extends string>({ items, active, onChange }: TabsProps<T>) {
    return (
        <div className={styles.tabs} role="tablist">
            {items.map((item) => {
                const badgeClass =
                    item.badge?.tone === 'warning' ? `${styles.badge} ${styles.warning}` : styles.badge;

                return (
                    <button
                        key={item.key}
                        type="button"
                        role="tab"
                        aria-selected={item.key === active}
                        className={item.key === active ? `${styles.tab} ${styles.isActive}` : styles.tab}
                        onClick={() => onChange(item.key)}
                    >
                        {item.label}
                        {item.badge !== undefined && <span className={badgeClass}>{item.badge.value}</span>}
                    </button>
                );
            })}
        </div>
    );
}
